var map = {
	"./aargau.gif": 9875,
	"./abafar.gif": 9971,
	"./abregado-rae.gif": 9656,
	"./agamar.gif": 8849,
	"./ahch-to.gif": 1782,
	"./akrit'tar.gif": 8467,
	"./alderaan.gif": 5974,
	"./aleen.gif": 8975,
	"./alzoc_iii.gif": 2045,
	"./ambria.gif": 1026,
	"./anaxes.gif": 876,
	"./ando.gif": 7976,
	"./bespin.gif": 6781,
	"./cantonica.gif": 9304,
	"./cato_neimoidia.gif": 4870,
	"./coruscant.gif": 1432,
	"./crait.gif": 7973,
	"./d'qar.gif": 4955,
	"./dagobah.gif": 5562,
	"./default.gif": 8489,
	"./default_enigma.gif": 1819,
	"./endor.gif": 1010,
	"./exegol.gif": 5580,
	"./felucia.gif": 4989,
	"./geonosis.gif": 3555,
	"./hosnian_prime.gif": 6102,
	"./hoth.gif": 3233,
	"./ilum.gif": 9043,
	"./jakku.gif": 6480,
	"./kamino.gif": 9545,
	"./kashyyyk.gif": 3525,
	"./kijimi.gif": 9975,
	"./mustafar.gif": 7073,
	"./mygeeto.gif": 1410,
	"./naboo.gif": 871,
	"./pasaana.gif": 8683,
	"./polis_massa.gif": 1031,
	"./saleucami.gif": 8645,
	"./takodana.gif": 751,
	"./tatooine.gif": 2531,
	"./utapau.gif": 648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2557;